(async function () {
    const CACHE_KEY = "intercom_jwt_cache";
    const SESSION_KEY = "intercom_session_id";
    const TOKEN_EXPIRY_MS = 55 * 60 * 1000; // 55 minutes
    let customerID = "";
    let customerEmail = "";

    function getOrCreateSessionId() {
        try {
            let sessionId = sessionStorage.getItem(SESSION_KEY);
            
            if (!sessionId) {
                if (window.crypto && crypto.randomUUID) {
                    sessionId = crypto.randomUUID();
                } else {
                    sessionId = 'sess_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
                }
                
                sessionStorage.setItem(SESSION_KEY, sessionId);
            }
            
            return sessionId;
        } catch (e) {
            console.error("Error generating session ID:", e);
            return 'temp_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
        }
    }

    function getCachedToken() {
        try {
            const cached = localStorage.getItem(CACHE_KEY);
            if (!cached) return null;

            const data = JSON.parse(cached);
            const now = Date.now();

            if (now >= data.expiresAt) {
                localStorage.removeItem(CACHE_KEY);
                return null;
            }

            return data;
        } catch (e) {
            console.error("Error reading cached token:", e);
            return null;
        }
    }

    function cacheToken(customerId, token) {
        try {
            const data = {
                customerId: customerId,
                token: token,
                expiresAt: Date.now() + TOKEN_EXPIRY_MS
            };
            localStorage.setItem(CACHE_KEY, JSON.stringify(data));
        } catch (e) {
            console.error("Error caching token:", e);
        }
    }

    async function init() {
        try {
            // Determine customer ID and email
            if (window.customerID) {
                // Logged in user
                customerID = window.customerID;
                customerEmail = window.customerEmail || "";
            } else {
                customerID = getOrCreateSessionId();
                customerEmail = "";
            }

            // Check if we have a valid cached token
            const cached = getCachedToken();
            if (cached && cached.customerId === customerID) {
                window.intercom_user_jwt = cached.token;
                return;
            }

            // Fetch new token from API
            const res = await fetch(
                `${window.backendApiEndpoint}api/intercom-jwt`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        customerID,
                        customerEmail
                    }),
                }
            );
            const intercomJWTResponse = await res.json();
            const token = intercomJWTResponse.token;

            window.intercom_user_jwt = token;
            cacheToken(customerID, token);
        } catch (error) {
            console.error("Intercom JWT: Failed to initialize:", error);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();
